import { PromptDto } from '../../components/types';

import fallbacks from './fallbacks.json';

export function getImageDataFallback(id: number): PromptDto['imageData'] {
    const lastThreeDigits = id % 1000;

    const fallback = fallbacks[lastThreeDigits] || fallbacks[0];

    return {
        url: ['https://avatars.mds.yandex.net/get-lpc', fallback.url].join('/'),
        colors: {
            MainColor: fallback.mainColor,
        },
    };
}
